import { useParams } from 'react-router-dom';
import { Box, Flex } from '@chakra-ui/react';
import moment from 'moment';

import { DownloadIcon } from 'Asset/icon';
import { useUserInfo } from 'Store/userInfo';
import { Condition, Iteration } from 'Component/others';
import ButtonSolid from 'UiKit/button/buttonSolid';
import { TextSemiBold } from 'UiKit/typography';
import useGetExportOperatorBreaks from 'Domain/report-attendance-operator-detail/useGetExportOperatorBreaks';
import useGetExportOperatorViolations from 'Domain/report-attendance-operator-detail/useGetExportOperatorViolations';

import { ReportAttendanceOperatorDetailText, tabOptions } from 'View/report-attendance-operator-detail/const';
import { useReportAttendanceOperatorDetailState } from 'View/report-attendance-operator-detail/state';
import { TabSkeleton } from 'View/report-attendance-operator-detail/component/skeleton';

import styles from './styles.module.css';

const Tab = ({ isFetching }) => {
  const { selectedTab, updateState, filterState, updateFilterState } = useReportAttendanceOperatorDetailState();
  const params = useParams();
  const { id, date } = params;
  const paramsDate = moment(date, 'DD-MM-YYYY');
  const { userId } = useUserInfo();

  const { mutate: mutateBreak } = useGetExportOperatorBreaks();
  const { mutate: mutateViolations } = useGetExportOperatorViolations();

  const handleExport = () => {
    const filter = { ...filterState, operatorId: id || userId, paramsDate };
    if (selectedTab === 'restViolation') mutateBreak(filter);
    else mutateViolations(filter);
  };

  return (
    <Condition statement={!isFetching} fallback={<TabSkeleton />}>
      <Box className={styles['tab__container']}>
        <Flex>
          <Iteration
            items={tabOptions}
            render={(opt) => {
              const isActive = selectedTab === opt.type;
              return (
                <Box
                  key={opt.type}
                  className={`${styles['tab__item']} ${isActive && styles['tab__item--actived']}`}
                  onClick={() => {
                    updateFilterState({
                      page: 1,
                    });
                    updateState({
                      selectedTab: opt.type,
                    });
                  }}
                >
                  <TextSemiBold className={styles['tab__text']}>{opt.label}</TextSemiBold>
                </Box>
              );
            }}
          />
        </Flex>

        <ButtonSolid className={styles['tab__button-export']} onClick={handleExport}>
          <DownloadIcon size="18px" />{' '}
          <TextSemiBold className={styles['tab_button-export--text']}>{ReportAttendanceOperatorDetailText.buttonExportText}</TextSemiBold>
        </ButtonSolid>
      </Box>
    </Condition>
  );
};

export default Tab;
